const segments = [
  'Convertible',
  'Coupe',
  'Crossover',
  'Hatchback',
  'Limousine',
  'Sedan',
  'SportsCar',
  'SUV',
  'Truck',
  'Van',
  'Wagon'
].reduce((icons, icon) => {
  icons[icon] = require(`./${icon}.svg`).default
  return icons
}, {})

export default segments

/**
 * Get an icon by the Segment name. Converts the human-readable body style
 * to it's PascalCase equivelant in order to determine the appropriate icon.
 * @param {String} name
 * @return {Object}
 */
export function getSegmentIcon (name) {
  name = name.replace(/[\s-/]/g, '')
  return segments[name]
}
